import { FoxBizRequest, FoxRestBizClient } from "@/api/client";

/**
 * 현장 정보 화면 관련 기능 클래스
 */
class FieldInfo {

    /**
     * 생성자
     */
    constructor() {
        this.currentPage = 1;
        this.listSize = 2147483647; // [주의] 쿼리 수정 하면 안됨. top size = int.max
        this.gridTopSize = 15;      // [주의] 쿼리 상의 top size 와 다름. 이것은 그리드용 top size.
    }

    /**
     * 공사현장 하위 메뉴 오픈 여부 조회 메서드
     * @param {String} idx
     * @returns 
     */
     getMenuShowYn(idx) {
        return new Promise((resolve, reject) => {
            
            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Cims.Biz.CimsPrjInfoBiz';
            request.methodId = 'GetMenuShowYn';
            request.parameters.idx = idx

            service.execute(request).then(response => {

                const tables = response.data.result.value;

                if (!!tables) resolve(tables);
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 현장 지역 정보 프로젝트 목록 조회
     * @param {Object} parameters 
     * @returns 
     */
     getAreaList(parameters) {
        return new Promise((resolve, reject) => {
            
            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Koreit.Biz.KRTMoveInBiz';
            request.methodId = 'GetKRTAreaList';
            request.parameters = parameters

            service.execute(request).then(response => {

                const rows = response.data.result.value.Table.rows;

                if (!!rows.length) resolve(rows);
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 현장 정보 프로젝트 목록 조회
     * @param {Object} parameters 
     * @returns 
     */
    getFieldList(parameters) {
        return new Promise((resolve, reject) => {
            
            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Koreit.Biz.KRTMoveInBiz';
            request.methodId = 'GetKRTProjectList';
            request.parameters = parameters

            service.execute(request).then(response => {

                const rows = response.data.result.value.Table.rows;

                if (!!rows.length) resolve(rows);
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 메인화면 현장 정보 프로젝트 목록 조회
     * @returns 
     */
    getProjectByMain(idx) {
        return new Promise((resolve, reject) => {
            
            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Cims.Biz.CimsPrjInfoBiz';
            request.methodId = 'GetProjectByMain';
            request.parameters.idx = idx

            service.execute(request).then(response => {

                const rows = response.data.result.value.Table.rows;

                if (!!rows.length) resolve(rows);
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 현장 정보 사업 개요 목록 조회
     * @param {Object} parameters 
     * @returns 
     */
     getFieldViewList(parameters) {
        return new Promise((resolve, reject) => {
            
            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Cims.Biz.CimsPrjInfoBiz';
            request.methodId = 'GetBusinessInfo';
            request.parameters = parameters

            service.execute(request).then(response => {

                const tables = response.data.result.value;

                if (!!tables) resolve(tables);
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 현장 정보 입주자모집공고 목록 조회
     * @param {Object} parameters 
     * @returns 
     */
     getParceloutInfo(parameters) {
        return new Promise((resolve, reject) => {
            
            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Cims.Biz.CimsPrjInfoBiz';
            request.methodId = 'GetParceloutInfo';
            request.parameters = parameters

            service.execute(request).then(response => {

                const tables = response.data.result.value;

                if (!!tables) resolve(tables);
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 현장 정보 분양사이트 목록 조회
     * @param {string} idx 
     * @returns 
     */
     getPrjEtcInfo(idx) {
        return new Promise((resolve, reject) => {
            
            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Cims.Biz.CimsPrjInfoBiz';
            request.methodId = 'GetPrjEtcInfo';
            request.parameters.idx = idx;

            service.execute(request).then(response => {

                const tables = response.data.result.value;

                if (!!tables) resolve(tables);
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 현장 정보 오시는 길 목록 조회
     * @param {string} idx 
     * @returns 
     */
     getModelHouseInfo(idx) {
        return new Promise((resolve, reject) => {
            
            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Cims.Biz.CimsPrjInfoBiz';
            request.methodId = 'GetModelHouseInfo';
            request.parameters.idx = idx;

            service.execute(request).then(response => {

                const tables = response.data.result.value;

                if (!!tables) resolve(tables);
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 현장 정보 공정현황 목록 조회
     * @param {string} idx 
     * @returns 
     */
     getKRTProjectWorkInfoList(idx) {
        return new Promise((resolve, reject) => {
            
            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Cims.Biz.CimsPrjInfoBiz';
            request.methodId = 'GetKRTProjectWorkInfoList';
            request.parameters.idx = idx;
            request.parameters.seq = null;

            service.execute(request).then(response => {

                const tables = response.data.result.value;

                if (!!tables) resolve(tables);
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 현장 정보 입주안내 조회
     * @param {object} parameter  
     * @returns 
     */
     getMoveinInfo(parameter) {
        return new Promise((resolve, reject) => {
            
            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Cims.Biz.CimsPrjInfoBiz';
            request.methodId = 'GetMoveinInfo';
            request.parameters = parameter;

            service.execute(request).then(response => {

                const tables = response.data.result.value;

                if (!!tables) resolve(tables);
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
     * 현장 정보 단지안내 목록 조회
     * @param {object} parameter 
     * @returns 
     */
    getEstateInfo(parameter) {
        return new Promise((resolve, reject) => {
            
            const url = process.env.VUE_APP_ANONYMOUSE_BIZ_SERVICE_REST_API;
            const service = new FoxRestBizClient(url, false);
            const request = new FoxBizRequest();
            request.classId = 'Site.Cims.Biz.CimsPrjInfoBiz';
            request.methodId = 'GetEstateInfo';
            request.parameters = parameter;

            service.execute(request).then(response => {

                const tables = response.data.result.value;

                if (!!tables) resolve(tables);
                else resolve(null);
            }).catch(error => reject(error));
        });
    }

    /**
    *  분양 사이트 새창으로 열기
    */
    newOpenClick (path)  {
        if (!!path) {
            window.open(`${path}`);
        }
        
    }
}

export const fieldInfo = new FieldInfo();